import { CarouselLeftArrowIcon } from '@components/Icons/CarouselLeftArrowIcon';
import { CarouselRightArrowIcon } from '@components/Icons/CarouselRightArrowIcon';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSwiper } from 'swiper/react';

const PrevButton: React.FC = memo(() => {
  const { t } = useTranslation();
  const swiper = useSwiper();
  const swipePrev = () => {
    if (swiper.animating) return;
    swiper.slidePrev();
  };
  return (
    <button
      onClick={swipePrev}
      className="absolute left-9 top-1/2 -translate-y-1/2 z-[300] hidden sm:flex items-center justify-center w-12 h-12 rounded-full bg-black/60 hover:bg-black/80 transition-all duration-200"
      aria-label={t('aria.previousSlide')}>
      <CarouselLeftArrowIcon />
    </button>
  );
});

const NextButton: React.FC = memo(() => {
  const { t } = useTranslation();
  const swiper = useSwiper();
  const swipeNext = () => {
    if (swiper.animating) return;
    swiper.slideNext();
  };
  return (
    <button
      onClick={swipeNext}
      className="absolute right-9 top-1/2 -translate-y-1/2 z-[300] hidden sm:flex items-center justify-center w-12 h-12 rounded-full bg-black/60 hover:bg-black/80 transition-all duration-200"
      aria-label={t('aria.nextSlide')}>
      <CarouselRightArrowIcon />
    </button>
  );
});

export { NextButton, PrevButton };
